<template>
    <input class="form-control text-right"
        type         = "text"
        v-model      = "displayValue"
        ref          = "currencyInp"
        @click       = "selectText($event)"
        @change      = "inputChange($event)"
        @keyup       = "$emit('keyup', $event)"
        @keypress    = "$emit('keypress', $event)"
        @keydown     = "onKeyDown"
        @keydown.f2  = "$emit('tecla', $event)"
        @focus       = "selectText($event)"
    />
</template>

<script>
export default {
    data() {
        return {
            // isInputActive : false,
            runOnce: false,
        }
    },

    methods : {
			inArray(needle, haystack, argStrict){
				var key    = '';
				var strict = !!argStrict;
				if (strict) {
					for (key in haystack) {
						if (haystack[key] === needle) return true;
					}
				} else {
					for (key in haystack) {
						if (haystack[key] == needle) return true;
					}
				}
				return false;
			},

			selectText(e) {
				let input = e.target;
				input.focus();
				input.select();
			},

			inputChange(e){
				e.target.value = this.currencyFormat(e.target.value);
				this.$emit('change',e);
			},

			currencyFormat(n){
				if(n != undefined){
					n = (typeof n != "string") ? n.toString() : n;
					let x   = parseFloat(n.replace(/,/g,'')).toFixed(2).split('.'); // remove Commas, convert to Float, add two decimal Digits, then split it
					let dec = (x[1] == undefined) ? ".00" : "."+x[1];               // get decimal part

					let int = (x[0] == '' || isNaN(x[0])) ? "0" : x[0];             // evaluate empty or Not Alphanumeric
					int = int.replace(/[^\d]/g,'')+ dec;                        // adding decimal
					int = int.replace(/(\d)(?=(\d{3})+\.)/g,"$1,");             // adding comma(s)
					return int;
				}else{
					this.runOnce = false;
				}
			},

			allowedKeys(){
				return [
					9,  // Tab
					8,  // Backspace
					13, // Enter
					110,190, // dot keys
					48,49,50,51,52,53,54,55,56,57,   // Digits (1-9)
					96,97,98,99,100,101,102,103,104,105, // Numpad (1-9)
					37,38,39,40  // Arrows
				];
			},

			onKeyDown(e){
				let allowedKeys = this.allowedKeys();

				if((this.value.toString().match(/\./g) || []).length > 0 && this.inArray(e.keyCode,['190','110']) ){// more than one point
					// console.log("Sorry one point at a time!!!!!!");
					e.preventDefault();
					return false;
				}
				if(this.inArray(e.keyCode,allowedKeys)){
					this.$emit('keydown', e);
				}
				else {
					e.preventDefault();
					return false;
				}
			},
    },

    props: ["value","maximum"],

    computed: {
			displayValue: {
				get: function() {
					if(!this.runOnce){
						this.runOnce = true;
						return this.currencyFormat(this.value);
					}
					return this.value;
				},

				set: function(modifiedValue) {
					this.$emit('input', modifiedValue);
					// let newValue = parseFloat(modifiedValue.replace(/[^\d\.]/g, ""))
					// if(isNaN(newValue)) newValue = null;
					// this.$emit('input', newValue);
				}
			},
    },
    mounted(){
        // this.$root.$on("currency-input-focus",()=>{
        //     this.focus("currencyInp");
        // });
    }
}
</script>
